import { DashboardLateralNav } from 'components/DashboardLateralNav';
import { Navbar } from 'components/Navbar';
import { useDisclose } from 'hooks/utilHooks';
import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';

import AssignmentIcon from '@mui/icons-material/Assignment';
import { Box, Container, Toolbar } from '@mui/material';

import { PartnerProfile } from './Profile';

const items = [
  {
    name: 'Perfil',
    url: `/profile`,
    component: <AssignmentIcon />,
    route: '/profile',
  },
];

export const Partner: FC = () => {
  const { isOpen, onToggle } = useDisclose(true);

  return (
    <Box sx={{ display: 'flex' }}>
      <DashboardLateralNav
        openSideMenu={isOpen}
        toggleDrawer={onToggle}
        items={items}
        setPageTitle={() => {}}
      />

      <Navbar
        openSideMenu={isOpen}
        toggleDrawer={onToggle}
        pageTitle="Perfil"
      />

      <Box
        component="main"
        sx={{
          backgroundColor: '#efefef',
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <Toolbar />

        <Container sx={{ py: 3 }}>
          <Switch>
            <Route exact path="/partner/profile">
              <PartnerProfile />
            </Route>
          </Switch>
        </Container>
      </Box>
    </Box>
  );
};

